// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTag = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M15.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3" />,
    <path
      fillRule="evenodd"
      d="M18.414 2h-5.828L1.63 12.954l8.288 9.471L22 11.442V5.586zM4.37 13.046L13.414 4h4.172L20 6.414v4.144l-9.919 9.017z"
    />
  );
export default SvgIconTag;
